import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HttpService } from '@core';
import { lnDtoToOrderState, LockersNetCustomerDto } from '@models/customer';
import { OrderState } from '../models';

const CUSTOMER_TRANSFER_URL = environment.lockersNet + environment.customerTransfer;

@Injectable()
export class CustomerTransferResolver {
    public constructor(private http: HttpService) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<Partial<OrderState>> | undefined {
        if (route.queryParamMap.get('dtt')) {
            return this.http
                .get<LockersNetCustomerDto>(`${CUSTOMER_TRANSFER_URL}${route.queryParamMap.get('dtt')}`, {
                    notify: 'NONE',
                })
                .pipe(
                    map((lnCustomer: LockersNetCustomerDto) => lnDtoToOrderState(lnCustomer)),
                    // if there is no customer for this token, just return an
                    // observable of undefined so we can proceed:
                    catchError(() => of(undefined)),
                );
        }
        return undefined;
    }
}
